import styled from 'styled-components'

import { theme } from 'styles/theme'

import { revealZoom } from '../reveal-zoom'

const { colors, fontSizes, lineHeights, media, radii, space } = theme

export const Section = styled.section`
  position: relative;
  box-sizing: border-box;
  width: 100%;
  padding: ${space['spacing-xxxl']} ${space['spacing-md']};
  overflow: hidden;
  background-color: ${colors['cashme-dark-blue']};

  @media (${media.desktop}) {
    min-height: 988px;
    padding: ${space['spacing-giga']} 0 0;
    background-color: #f4f6fb;
  }
`

export const BackgroundImage = styled.div`
  position: relative;
  display: none;

  @media (${media.desktop}) {
    position: absolute;
    inset: 0 0 0 -30%;
    display: block;

    img {
      object-fit: cover;
      object-position: right center;
    }

    ${revealZoom}
  }
`

export const Panel = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-md']};
  width: 100%;
  margin-left: auto;
  color: ${colors['neutral-text-contrast-default']};

  h2 {
    margin: 0;
    font-size: ${fontSizes['font-size-mobile-heading-2']};
    line-height: 1.2;
    letter-spacing: -0.72px;
  }

  @media (${media.desktop}) {
    gap: ${space['spacing-xl']};
    width: 677px;
    min-height: 908px;
    padding: ${space['spacing-giga']} 136px ${space['spacing-giga']} ${space['spacing-giga']};
    border-radius: 80px 0 0;
    background-color: ${colors['cashme-dark-blue']};

    h2 {
      font-size: ${fontSizes['font-size-heading-2']};
      line-height: ${lineHeights['font-line-height-sm']};
      letter-spacing: -0.96px;
    }
  }
`

export const Highlight = styled.span`
  color: ${colors['cashme-blue-neon']};
  font-weight: 600;
`

export const MobileImage = styled.div`
  position: relative;
  width: 100%;
  height: 258px;
  overflow: hidden;
  border-radius: ${radii['corner-radius-lg']};

  img {
    object-fit: cover;
    object-position: center;
  }

  ${revealZoom}

  @media (${media.desktop}) {
    display: none;
  }
`

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-md']};

  .ds-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: ${space['spacing-mega']};
    padding: 0 ${space['spacing-sm']};
    border-radius: ${radii['corner-radius-pill']};
    background-color: ${colors['pink-text-contrast']};
    transition: background-color 180ms ease;

    &:hover {
      background-color: ${colors['pink-background-strong-pressed']};
    }

    &:focus-visible {
      outline: 2px solid ${colors['neutral-border-default']};
      outline-offset: 3px;
    }
  }

  @media (${media.desktop}) {
    gap: ${space['spacing-xl']};

    .ds-button {
      width: 230px;
      gap: ${space['spacing-sm']};
    }
  }
`

export const Paragraphs = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-md']};

  p {
    margin: 0;
    font-size: ${fontSizes['font-size-body-small']};
    line-height: ${lineHeights['font-line-height-lg']};
  }
`

export const HighlightGrid = styled.ul`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${space['spacing-xs']};
  margin: 0;
  padding: 0;
  list-style: none;

  @media (${media.desktop}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: ${space['spacing-xs']} ${space['spacing-sm']};
  }
`

export const HighlightCard = styled.li`
  display: flex;
  align-items: center;
  gap: ${space['spacing-sm']};
  min-height: 72px;
  padding: ${space['spacing-md']} ${space['spacing-xs']};
  border-radius: ${radii['corner-radius-md']};
  background-color: ${colors['blue-background-strong-default']};

  svg {
    flex: 0 0 ${space['spacing-md']};
  }

  p {
    margin: 0;
    font-size: ${fontSizes['font-size-body-small']};
    line-height: ${lineHeights['font-line-height-lg']};
  }

  @media (${media.desktop}) {
    min-height: 78px;
    padding: ${space['spacing-sm']} ${space['spacing-xs']};
  }
`

export const Connector = styled.div`
  display: none;

  @media (${media.desktop}) {
    position: absolute;
    z-index: 2;
    top: 200px;
    right: 644px;
    display: block;
    width: 67px;
    height: 80px;
  }
`
